<div class="wm-m-app-chooser">
  <!-- If there are no packages -->
  @if (!loadingPackages) {
    @if (virtualPackages) {
      <wm-app-list [packages]="virtualPackages" [projectId]="data.projectId" [variantCallbacks]="variantCallbacks" [interactive]="false"></wm-app-list>
    }
  }
  @if (loadingPackages) {
    <div class="loading-spinner">
      <div>
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div>Loading...</div>
    </div>
  }
</div>
